import { FeedFilterParamType, FullPost } from 'model';
import { createContext, useContext, useMemo } from 'react';

const filterByPostType = (filterBy: string, feed: FullPost[]) => {
	if (filterBy === 'all') {
		return feed;
	} else {
		return feed.filter(item => item.postType === filterBy);
	}
};
const filterByTopic = (topic: string, feed: FullPost[]) => {
	if (topic === '') {
		return feed;
	} else {
		return feed.filter(item => item.topic.toLowerCase() === topic);
	}
};
export const useFeedFilters = (feedFilterValues: FeedFilterParamType, feed?: FullPost[]) => {
	const { filterBy, topic } = feedFilterValues;

	const fullFeed: FullPost[] | null = useMemo(() => {
		if (feed) {
			let filteredFeed: FullPost[] = feed;

			if (filterBy) {
				filteredFeed = filterByPostType(filterBy, filteredFeed);
			}

			if (topic) {
				filteredFeed = filterByTopic(topic, filteredFeed);
			}

			return filteredFeed;
		}
		return null;
	}, [feed, filterBy, topic]);

	return {
		fullFeed
	};
};

export interface FeedFiltersContextValue {
	filters: FeedFilterParamType;
	setFilters: (values: FeedFilterParamType) => void;
}

export const FeedFiltersContext = createContext<FeedFiltersContextValue>({
	filters: { topic: '' },
	setFilters: () => {}
});

export function useFeedFiltersContext(): FeedFiltersContextValue {
	return useContext(FeedFiltersContext);
}
